import { addErrorSDKToast, modifyUrlForProxy } from 'src/utils/helpers'

const SupportLink = () => {
  const appBackendWebOrigin = window.location.origin
  const pathToSupportRoute = '/api/zoomapp/support'
  const url = appBackendWebOrigin + pathToSupportRoute
  const handleClick = () => {
    try {
      window.zoomSdk.openUrl({ url })
    } catch (error) {
      addErrorSDKToast(error)
    }
  }

  return (
    <button onClick={handleClick} className="text-sm text-primaryBlue">
      Support
      <img
        className="inline pl-1"
        src={modifyUrlForProxy('/pop_window.png')}
        alt="external support link"
      />
    </button>
  )
}

export default SupportLink
